import React from "react";
import BondRetrievalBasicInformationBase from "../../../../features/bonds/shared/components/BondRetrievalBasicInformationBase";
import { RETRIEVAL_BASIC_INFO_CONFIG } from "../../../../features/bonds/shared/retrievalBasicInformationConfig";
import { RETRIEVE_GLOBAL_DATA_ROLE_DISABLED } from "./bondRetrieveSharedPropTypes";

export function createRetrievalBasicInformation(kind) {
  const Component = (props) => (
    <BondRetrievalBasicInformationBase
      config={RETRIEVAL_BASIC_INFO_CONFIG[kind]}
      {...props}
    />
  );
  Component.displayName = `${kind.charAt(0).toUpperCase()}${kind.slice(1)}BasicInformation`;
  Component.propTypes = RETRIEVE_GLOBAL_DATA_ROLE_DISABLED;
  return Component;
}
